/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-05-20 14:30:34
 * @LastEditTime: 2022-03-04 18:25:06
 */
//vuex计算属性，通过计算属性来访问所有模块下的state
const getters = {
  Grouping: state => state.GroupingList.Grouping,
  KeepAlive: state => state.device.KeepAlive,
  i18n: state => state.device.i18n,
  NavShow: state => state.dashboard.NavShow,
  Logo: state => state.dashboard.Logo,
  GroupingName: state => state.device.GroupingName,
  Grouplist: state => state.GroupingList.Grouplist,
  defaultGroupId: state => state.dashboard.defaultGroupId,
  websiteType: state => state.dashboard.websiteType,
  deviceGroup: state => state.monitorDevice.deviceGroup,
  terminalDevice: state => state.monitorTerminal.terminalDevice,
  terminalId: state => state.variable.terminalId
}

export default getters